/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Sales_Order_Not_Ready_For_LockInputs */

const en_error_sales_order_not_ready_for_lock = /** @type {(inputs: Error_Sales_Order_Not_Ready_For_LockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business Central could not take this order yet: read what it lacks.`)
};

/**
* | output |
* | --- |
* | "Business Central could not take this order yet: read what it lacks." |
*
* @param {Error_Sales_Order_Not_Ready_For_LockInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_sales_order_not_ready_for_lock = /** @type {((inputs?: Error_Sales_Order_Not_Ready_For_LockInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Sales_Order_Not_Ready_For_LockInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_sales_order_not_ready_for_lock(inputs)
});